var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uik-progress-bar__wrapper"},[_c('div',{staticClass:"uik-progress-bar__progressLine",class:{
            'uik-progress-bar__progressLine--primary': _vm.color === 'primary',
            'uik-progress-bar__progressLine--secondary': _vm.color === 'secondary',
            'uik-progress-bar__progressLine--warning': _vm.color === 'warning',
            'uik-progress-bar__progressLine--error': _vm.color === 'error',
            'uik-progress-bar__progressLine--success': _vm.color === 'success'
        },style:('width:' + _vm.fill + '%;' + _vm.bgColor)})])
}
var staticRenderFns = []

export { render, staticRenderFns }